export default {
  tenantPendingHint: 'Payment details submitted. Your package will be activated after finance approval.',
  packageName: 'Package name',
  years: "{n} years",
  reviewTitle: "Bank transfer review",
  pending: "Pending",
  approved: "Approved",
  rejected: "Rejected",
  purchaseKind: "Purchase type",
  kind_member_plan: "Membership plan",
  kind_resource_recharge: "Resource top-up",
  kind_sxa_service: "Association plan",
  submittedAt: "Submitted at",
  viewReceipt: "View transfer proof",
  reviewNote: "Review note",
  approve: "Confirm receipt",
  reject: "Reject",
  approveConfirm: "Verify that the bank received the payment. Confirming activates the purchase. Enter an optional review note:",
  rejectConfirm: "Rejecting closes this order. The buyer can place a new order. Enter the rejection reason:",
  confirmTitle: 'Confirm purchase: {name}', method: 'Payment method', selected: 'Selected', confirmPay: 'Confirm payment ¥{amount}',
  noMethods: 'No payment methods available. Contact the platform administrator.', free: 'This package is free. Confirm to activate it.',
  paymentHint: 'WeChat payments activate purchases automatically. Bank transfers require finance approval after submitting proof.',
  loadFailed: 'Could not load payment methods. Try again.', failed: 'Could not complete the operation. Try again.',
  transferTitle: 'Submit bank transfer for review', due: 'Amount due', receivingAccount: 'Platform collection account',
  accountName: 'Payee', bankName: 'Bank', bankAccount: 'Account number', bankBranch: 'Bank branch', financeContact: 'Finance contact', reference: 'Transfer reference',
  transferHint: 'Transfer the exact order amount and upload proof of payment. Your purchase will be activated after finance confirms receipt.',
  payerName: 'Paying company', payerBank: 'Paying bank', payerAccount: 'Payer account number', amount: 'Transfer amount (CNY)',
  transferredAt: 'Transfer time', transactionNo: 'Bank transaction number', remark: 'Transfer note', receipt: 'Proof of transfer',
  receiptHelp: 'PNG / JPG / WebP, up to 500 KB.', required: 'Enter or upload: {field}',
  amountMismatch: 'The transfer amount must match the order amount.', submitReview: 'Submit for review',
  submitted: 'Transfer information submitted for finance review.', cancelFailed: 'Could not cancel the order. Try again.', pendingReview: 'Awaiting finance review'
}
